import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useContext } from 'react';
import { MaterialBoolControl, StrictNumberInput } from 'console/shared/components/fields';
import { useEditingProps } from '../../utils/unpack-props';
import { HeatingCircuit } from 'z3k-config';
import { useBox } from 'shared/hooks/utils';
import { SettingFullRow } from 'console/device-settings/z3k/components/material-utils/settings-card/full-row';
import { HeatingCircuitContext } from 'console/device-settings/z3k/components/heating-circuits/context/type';
import { Z3KSettings } from 'console/device-settings/z3k/provider/types';
import { Control } from 'console/shared/components/fields/control';
import { useBooleanState } from 'shared/hooks/state/boolean';
export const DeltaTemp = memo(function DeltaTempImpl() {
    const { item, id, z3k_name, onChange } = useContext(HeatingCircuitContext);
    const hcBox = useBox(item);
    const { deviceFirmwareVersion } = useContext(Z3KSettings);
    const deltaTempEditingProps = useEditingProps(id, z3k_name, 'delta_temp');
    const [is_delta_visible, , , toggleVisible] = useBooleanState(!!deltaTempEditingProps.value);
    const onChangeDeltaVisible = useCallback(() => {
        toggleVisible();
        onChange({
            ...hcBox.current,
            delta_temp: 0,
        });
    }, [onChange]);
    const delta_temp_field = useCallback((input_props) => (_jsx(StrictNumberInput, { editDividedBy: 10, min: 0.1, max: 25, step: 0.1, ...input_props })), []);
    if (HeatingCircuit.isConsumer(item) === false) {
        return null;
    }
    if (HeatingCircuit.isWaterConsumerMode(item)) {
        return null;
    }
    if (item.pza == null) {
        return null;
    }
    if (deviceFirmwareVersion < 140) {
        return null;
    }
    return (_jsxs(SettingFullRow, { children: [_jsx(MaterialBoolControl, { color: "primary", label: "\u0417\u0430\u043F\u0440\u0435\u0442 \u0440\u0430\u0431\u043E\u0442\u044B \u041F\u0417\u0410 \u043F\u0440\u0438 \u043E\u0442\u043A\u043B\u043E\u043D\u0435\u043D\u0438\u0438 \u0446\u0435\u043B\u0435\u0432\u043E\u0439 \u0442\u0435\u043C\u043F\u0435\u0440\u0430\u0442\u0443\u0440\u044B", help_id: "heating_circuits_delta_temp", value: is_delta_visible, onChange: onChangeDeltaVisible }), is_delta_visible && (_jsx(Control, { label: "\u041E\u0442\u043A\u043B\u044E\u0447\u0430\u0442\u044C \u041F\u0417\u0410 \u043F\u0440\u0438 \u043E\u0442\u043A\u043B\u043E\u043D\u0435\u043D\u0438\u0438 \u0446\u0435\u043B\u0435\u0432\u043E\u0439 \u00B0t \u0431\u043E\u043B\u0435\u0435, \u0447\u0435\u043C", help_id: "heating_circuits_delta_temp_input", ...deltaTempEditingProps, field: delta_temp_field }))] }));
});
